module.exports = __webpack_public_path__ + "static/media/NineTopBackground.684fbc80.svg";